import { fork } from 'redux-saga/effects';
import { LoadOptions, LoadType } from 'store/sagas/apiService/types';
import { queryData } from 'store/sagas/apiService';

export function* commercialMarketLandingPageHandler() {
  const loadOptions: LoadOptions<LoadType.AreasWithCommercialInfoPage> = {
    loadType: LoadType.AreasWithCommercialInfoPage,
    meta: {
      variables: {},
    },
  };
  yield fork(queryData, loadOptions);
}
